export default "__VITE_ASSET__BCtZBmcs__"